export default __webpack_public_path__ + "static/media/bg-privacy.ff7b673e.png";